<template>
     <div class="carBox">
        <el-card class="box-card" style="width: 280px;margin-right: 20px">
            <el-upload class="upload-demo" drag ref="upload" name="upFile" 
                :action="uploadAction"
                :headers="uploadHeaders"
                :on-success="handleUploadSuccess"
                :before-upload="beforeUpload"
                :data="upData"
                :file-list="fileList">
                <img class="upload-icon" src="/new-ui/icon_upload.png" alt="上传" />
                <div class="el-upload__text">将文件拖到此处</div>
                <div class="upload-btn-row">
                    <span class="upload-btn">点击上传</span>
                </div>
            </el-upload>
            <div style="width: 100%;" v-if="data_type==9">
                <template v-for="msg in msgList">
                    <el-alert :title="msg" type="error" :closable="false" :key="msg" style="margin-top: 10px"></el-alert>
                </template>
            </div>
            <div class="btnBox">
                <el-button type="primary" @click="saveData" v-if="data_type==1">确认导入</el-button>
                <el-button type="warning" @click="abnormalData" v-if="data_type==9">存入异常列表</el-button>
                <el-button @click="discardData" v-if="data_type>0">丢弃数据</el-button>
            </div>
        </el-card>
        <div style="width: calc(100% - 300px); height: 100%">
            <el-row style="width: 100%">
                <el-col :span="24">
                    <el-card class="box-card">
                        <div slot="header" style="text-align: center">
                            <span style="font-size: 22px;font-weight: bold">{{report.work_type}}记录表</span>
                        </div>
                        <div class="el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                            <div class="el-table__body-wrapper is-scrolling-none">
                                <table class="el-table__body" width="100%" cellspacing="0" cellpadding="0" border="0">
                                    <tbody>
                                        <tr class="el-table__row">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>工程名称：</span></div>
                                            </td>
                                            <td class="el-table__cell" colspan="3">
                                                <div class="cell"><span>{{report.unit_name}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>设备编号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.device_code}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>通道号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.channel_no}}</span></div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row el-table__row--striped">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>施工单位：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.construction_unit}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>监测单位：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.monitor_unit}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>开始时间：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.begin_time}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>结束时间：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.end_time}}</span></div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>单元：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.unit_code}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>作业方式：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.work_type}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>孔号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.hole_code}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>孔序：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.hole_order}}</span></div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row el-table__row--striped">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>段号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.segment_no}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>段长(m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.segment_length}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>段顶(m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.segment_top}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>段底(m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.segment_bottom}}</span></div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>桩号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.pile_no}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>抬动孔号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.lift_hole_no}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>孔口高程(m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.hole_height}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>排序：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.order_index}}</span></div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row el-table__row--striped">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>水灰比：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.water_ash}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>砂灰比：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.sand_ash}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>压力设定(Mpa)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.pressure_set}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>水泥比重(g/cm3)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.water_mud_proportion}}</span></div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>砂比重(g/cm3)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.sand_proportion}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>循环方式：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.circle_type}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>涌水压力(Mpa)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.water_pressure}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>地下水位(m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.groundwater_level}}</span></div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row el-table__row--striped" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>注浆量(L)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.grout_volume}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>累计注灰量(Kg)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.ash_volume}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>单位注灰量(kg/m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.ash_volume_unit}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>砂量(Kg)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.sand_volume}}</span></div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>余浆量(L)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.grout_volume_throw}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>弃灰量(Kg)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.ash_volume_throw}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>管容(L)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.piping_volume}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>管道占灰量(Kg)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.piping_ash_volume}}</span></div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row el-table__row--striped" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>外加剂1(Kg)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.material1_total}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>外加剂2(Kg):</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.material2_total}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>防伪特征码：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.security_code}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>纯灌时间：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.grout_duration_str}}</span></div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row el-table__row--striped" v-if="report.work_type_int ==2 || report.work_type_int ==3">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>透水率(Lu)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.permeable_rate}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>防伪特征码：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.security_code}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>纯灌时间：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span>{{report.grout_duration_str}}</span></div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span></span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span></span></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <el-row style="width: 100%; height: 455px; margin-top: 20px;margin-left: 0;margin-right: 0;" :gutter="20">
                <el-col :span="12" style="padding-left: 0;height:100%">
                    <el-card class="box-card" style="height: 100%">
                        <div slot="header" class="clearfix">
                            <span class="title-bar"></span>
                            <span>采样数据</span>
                        </div>
                        <el-table :data="samplingList" border stripe height="370">
                            <el-table-column prop="sampling_time_str" label="时间" sortable="custom"></el-table-column>
                            <el-table-column prop="flow" label="流量(L/Min)" sortable="custom"></el-table-column>
                            <el-table-column prop="pressure" label="压力(Mpa)" sortable="custom"></el-table-column>
                            <el-table-column prop="density" label="密度(g/cm3)" sortable="custom"></el-table-column>
                            <el-table-column prop="grout_volume" label="注浆量(L)" sortable="custom" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5"></el-table-column>
                            <el-table-column prop="permeable_rate" label="透水率(Lu)" sortable="custom" v-if="report.work_type_int ==2 || report.work_type_int ==3"></el-table-column>
                            <el-table-column prop="remark" label="备注" sortable="custom"></el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
                <el-col :span="12" style="padding-right: 0;height:100%">
                    <el-card class="box-card" style="height: 100%">
                        <div slot="header" class="clearfix">
                            <span class="title-bar"></span>
                            <span>数据统计图</span>
                        </div>
                        <el-radio-group v-model="echarts_show" size="small" @input="changeEcharts">
                            <el-radio-button label="1">流量</el-radio-button>
                            <el-radio-button label="2">压力</el-radio-button>
                            <el-radio-button label="3">密度</el-radio-button>
                            <el-radio-button label="4">抬动</el-radio-button>
                        </el-radio-group>
                        <div class="echartsimp" id="myChart1">
                            
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import editutil from '@/libs/editutil'
import {dealPreviewReport} from "@/api/workreport";
import { applyLineChartTheme } from '@/libs/lineChartTheme'
// 引入基本模板
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/grid')
require('echarts/lib/component/legend')

export default {
    name: 'checkholeworkreportImport',
    mixins: [editutil],
    data() {
        return {
            menu_id: 5995,
            uploadAction: "/api/admin/workreport/preImport",
            fileList: [],
            data_type: 0,
            msgList: [],
            report: {
                work_type_int: 1
            },
            samplingList: [],
            echarts_show: 0,
            line1: [],
            line2: [],
            line3: [],
            line4: [],
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '8%',
                    right: '4%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    name:'',
                    type: 'value'
                },
                series: [
                    {
                        name: '',
                        type: 'line',
                        areaStyle: {},
                        data: []
                    }
                ]
            },
            upData: {
                report_type: 11
            }
        };
    },
    methods: {
        handleUploadSuccess(res, file){
            this.resetData()
            if(res.code ==1){
                this.$msgs("请预览该报告数据！");
                this.report = res.data.report
                this.samplingList = res.data.samplingList
                this.data_type = res.data.data_type
                this.msgList = res.data.msgList
                this.line1 = res.data.line1
                this.line2 = res.data.line2
                this.line3 = res.data.line3
                this.line4 = res.data.line4
                this.option.xAxis.data = res.data.xAxis
                this.echarts_show = '1'
                this.changeEcharts('1')
            }else{
                this.$message({
                    type: 'error',
                    duration: 0,
                    showClose: true,
                    message: res.msg
                });
            }
        },
        beforeUpload(file){
            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!isLt2M) {
                this.$message.error('上传文件大小不能超过5MB!');
            }
            return isLt2M;
        },
        changeEcharts(e){
            if(e =='1'){
                this.option.yAxis.name = '流量(L/Min)'
                this.option.series[0].name = '流量(L/Min)'
                this.option.series[0].data = this.line1
            }else if(e=='2'){
                this.option.yAxis.name = '压力(Mpa)'
                this.option.series[0].name = '压力(Mpa)'
                this.option.series[0].data = this.line2
            }else if(e=='3'){
                this.option.yAxis.name = '密度(g/cm3)'
                this.option.series[0].name = '密度(g/cm3)'
                this.option.series[0].data = this.line3
            }else if(e=='4'){
                this.option.yAxis.name = '抬动(um)'
                this.option.series[0].name = '抬动(um)'
                this.option.series[0].data = this.line4
            }
            var myChart1 = echarts.init(document.getElementById("myChart1"));
            myChart1.setOption(applyLineChartTheme(this.option));
        },
        saveData(){
            dealPreviewReport(this.report.id, 1).then(res=>{
                if(res.code == 1){
                    this.resetData()
                    this.$msgs(res.msg);
                }else{
                    this.$message({
                        type: 'error',
                        duration: 0,
                        showClose: true,
                        message: res.msg
                    });
                }
            })
        },
        abnormalData(){
            dealPreviewReport(this.report.id, 0).then(res=>{
                if(res.code == 1){
                    this.resetData()
                    this.$msgs(res.msg);
                }else{
                    this.$message({
                        type: 'error',
                        duration: 0,
                        showClose: true,
                        message: res.msg
                    });
                }
            })
        },
        discardData(){
            dealPreviewReport(this.report.id, -1).then(res=>{
                if(res.code == 1){
                    this.resetData()
                    this.$msgs(res.msg);
                }else{
                    this.$message({
                        type: 'error',
                        duration: 0,
                        showClose: true,
                        message: res.msg
                    });
                }
            })
        },
        resetData(){
            this.data_type =0
            this.msgList = []
            this.fileList = []
            this.report = {work_type_int: 1}
            this.samplingList = []
            this.echarts_show = 0
            this.line1 = []
            this.line2 = []
            this.line3 = []
            this.line4 = []
            this.option.yAxis.name = ''
            this.option.series[0].name = ''
            this.option.series[0].data = []
            var myChart1 = echarts.init(document.getElementById("myChart1"));
            myChart1.setOption(applyLineChartTheme(this.option));
        }
    }
};
</script>
<style lang="less" scoped>
    .upload-demo /deep/ .el-upload-dragger {
        width: 240px;
    }
    .el-table /deep/ .el-table__cell {
        padding: 10px 0;
    }
    .el-card /deep/ .el-card__header {
        padding: 10px 20px;
    }
    .echartsimp{
        width: 100%;
        height: 340px;
        margin-top: 0;
    }
    .btnBox {
        width: 100%;
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
    }
</style>